<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="card-title">Company Join Requests</h4>
          <b-form-radio-group
            v-model="status"
            :options="statusOptions"
            @input="handleStatusChange"
            buttons
          ></b-form-radio-group>
        </div>
        <div class="card-body">
          <div v-if="hasNoCompanies">No Results</div>
          <div class="table-responsive">
            <BTable
              v-if="!hasNoCompanies"
              :items="companies"
              :fields="fields"
              :busy="isTableBusy"
            >
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <template v-slot:head()="data">
                <span class="text-info">{{ data.label }}</span>
              </template>
              <template v-slot:cell(company)="data">
                <div>
                  <a v-if="data.item.logo" :href="data.item.logo" target="_blank"
                    ><img :src="data.item.logo" class="company-logo"
                  /></a>
                  {{ data.item.company }}
                </div>
              </template>
              <template v-slot:cell(actions)="data">
                <div class="btn-group">
                  <BButton
                    class="fa"
                    v-bind:class="{
                      'fa-check': !isSpinning('approve', data.item.requestId)
                    }"
                    size="sm"
                    :disabled="disableButtons"
                    variant="success"
                    @click.prevent="
                      handleApproveCompany(data.index, data.item.id)
                    "
                  >
                    <BSpinner
                      class="spinner-border spinner-border-sm"
                      v-if="isSpinning('approve', data.item.id)"
                      label="Spinning"
                    ></BSpinner>
                  </BButton>
                  <BButton
                    v-if="status === 'pending'"
                    class="fa"
                    v-bind:class="{
                      'fa-times': !isSpinning('reject', data.item.id)
                    }"
                    size="sm"
                    :disabled="disableButtons"
                    variant="danger"
                    @click.prevent="
                      handleRejectCompany(data.index, data.item.id)
                    "
                  >
                    <BSpinner
                      class="spinner-border spinner-border-sm"
                      v-if="isSpinning('reject', data.item.requestId)"
                      label="Spinning"
                    ></BSpinner>
                  </BButton>
                </div>
              </template>
            </BTable>
            <BPagination
              v-if="showPagination"
              :disabled="isTableBusy"
              v-model="pagination.currentPage"
              @input="fetchCompanies"
              :total-rows="pagination.total"
              :per-page="pagination.perPage"
              align="center"
              aria-controls="company-table"
              class="mt-4"
            ></BPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  BTable,
  BPagination,
  BButton,
  BSpinner,
  BFormRadioGroup
} from "bootstrap-vue";

export default {
  components: {
    BTable,
    BPagination,
    BButton,
    BSpinner,
    BFormRadioGroup
  },
  data() {
    return {
      isTableBusy: true,
      companies: [],
      disableButtons: false,
      spinningButton: {
        buttonType: null,
        requestId: null
      },
      fields: ["company", "team", "team_owner", "members", "status", "actions"],
      status: "pending",
      statusOptions: ["pending", "rejected"],
      pagination: {
        currentPage: 1,
        total: 0,
        perPage: 10
      }
    };
  },
  computed: {
    hasNoCompanies() {
      return !this.isTableBusy && this.companies.length === 0;
    },
    showPagination() {
      return (
        this.companies.length && this.pagination.total > this.pagination.perPage
      );
    }
  },
  methods: {
    fetchCompanies() {
      this.isTableBusy = true;
      this.$http
        .get("/enroll_admin/company-join-request", {
          params: {
            page: this.pagination.currentPage,
            per_page: this.pagination.perPage,
            status: this.status
          }
        })
        .then(({ data }) => {
          this.pagination.currentPage = data.current_page;
          this.pagination.total = data.total;
          this.companies = data.data.map(this.formatResponse);
        })
        .finally(() => (this.isTableBusy = false));
    },
    isSpinning(buttonType, id) {
      return (
        this.spinningButton.buttonType === buttonType &&
        this.spinningButton.requestId === id
      );
    },
    formatResponse(company) {
      return {
        id: company.id,
        company: company.name_fr,
        team: company.team.name,
        team_owner: company.team.owner.email,
        status: company.status,
        members: company.team.users.map(user => user.email).join(","),
        isBusy: false,
        logo: company.logo
      };
    },
    handleApproveCompany(index, companyId) {
      this.toggleButtonsState("approve", companyId);
      return this.updateCompany({ companyId, status: "active" }, index);
    },
    updateCompany({ companyId, ...payload }, index) {
      return this.$http
        .put(`/enroll_admin/companies/${companyId}/status`, payload)
        .then(() => {
          this.companies.splice(index, 1);
        })
        .finally(() => {
          this.toggleButtonsState();
        });
    },
    handleRejectCompany(index, companyId) {
      this.toggleButtonsState("reject", companyId);
      return this.updateCompany({ companyId, status: "rejected" }, index);
    },
    toggleButtonsState(buttonType, companyId) {
      this.disableButtons = !this.disableButtons;
      if (this.spinningButton.buttonType === null) {
        this.spinningButton = {
          buttonType,
          requestId: companyId
        };
      } else {
        this.spinningButton = {
          buttonType: null,
          requestId: null
        };
      }
    },
    handleStatusChange() {
      this.pagination.currentPage = 1;
      this.fetchCompanies();
    }
  },
  created() {
    this.fetchCompanies();
  }
};
</script>
